import React, { useState, useRef, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { 
    Flex, Box, Heading, Input, Button, ButtonGroup, Text, CircularProgress, CircularProgressLabel,
    InputGroup, InputLeftElement, InputRightElement, Icon, IconButton, Select,
    Stack, HStack, Image, Wrap, WrapItem, Center, InputRightAddon,
    Table, Thead, Tbody, Tfoot, Tr, Th, Td, TableCaption, TableContainer, useDisclosure, useToast,
    VStack, Badge, Alert, AlertTitle
} from '@chakra-ui/react';
import ReactPaginate from 'react-paginate';
import { MdSettings, MdAdd, MdAddCircleOutline, MdCalendarToday, MdSearch, MdEdit, MdDeleteForever, MdSave, MdDownload } from 'react-icons/md';
import { BsArrowLeftCircle, BsArrowRightCircle } from 'react-icons/bs';
import { useNavigate, useLocation } from 'react-router-dom';
import { FormattedDate, FormattedTime } from 'react-intl';
import { MultiSelect } from "react-multi-select-component";
import axios from 'axios';
import _ from 'lodash';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import DatePicker from 'react-date-picker';
import "react-date-picker/dist/DatePicker.css";
import 'react-calendar/dist/Calendar.css';
import { confirmChoice } from "../../utils/helpers";
import { PAGINATION_LIST, AUTHORIZE_TYPES, IS_AUTHORIZED } from "../../constants";
import { sleep } from "../../utils/helpers"
import httpClient from '../../services/http-client';

const SORT_BY_LIST = [
    { title: "Theo thời gian", value: "id" },
    { title: "Theo họ tên", value: "full_name" },
];

const SORT_DIR_LIST = [
    { title: "Giảm dần", value: "desc" },
    { title: "Tăng dần", value: "asc" }, 
];

const MAX_PURCHASING_APPROVE = 3;
const MAX_SUPPLIER_DELIVERY = 7;

function QuanLyDonHang() {
    const [ cookies, setCookie, removeCookie ] = useCookies(["loginCookie"]);
    const initialRef = useRef(null);
    const toast = useToast();
    const navigate = useNavigate();
    const { search } = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [isAllowAccessThisPage, setIsAllowAccessThisPage] = useState(true);
    const [settingDatas, setSettingDatas] = useState({});
    const [ivtYeuCauMuaHangs, setIvtYeuCauMuaHangs] = useState([]);
    const [selectedStoreNames, setSelectedStoreNames] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(25);
    const [order_by, setOrderBy] = useState(SORT_BY_LIST[0]["value"]);
    const [order_dir, setOrderDir] = useState(SORT_DIR_LIST[0]["value"]);
    const [searchText, setSearchText] = useState("");
    const [selectedFromDate, setSelectedFromDate] = useState(null);
    const [selectedToDate, setSelectedToDate] = useState(null);
    const [isExportPDF, setIsExportPDF] = useState(false);
    const htmlDownloadRef = useRef();

    const query = new URLSearchParams(search);
    const page = query.get("page");
    // const pageCount = Math.ceil(total_count / limit);
    const mounted = useRef();

  useEffect(() => {
        if(!mounted.current) {
            // if(cookies.loginCookie?.data?.scope !== "admin") {
            //     setIsAllowAccessThisPage(false);
            // }
            loadSetting();
            mounted.current = true;
        }
    }, []);
    //console.log("---- settingDatas:", settingDatas)
    const loadSetting = async() => {
        setIsLoading(true);
        const res = await httpClient.get(`/setting`);
        // console.log("--- loadSetting res:", res);
        if(!res.data.error) {
            setSettingDatas(res.data.data);
            setIsLoading(false);
        } else {
            toast({
                title: "Lỗi load cài đặt!",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
            setIsLoading(false);
        }
    }

    const getIVTYeuCauMuaHangs = async(params) => {
        let queryParams = `?limit=${limit}&order_by=${order_by}&order_dir=${order_dir}`;
        if(params?.searchText) {
            queryParams += `&searchText=${params.searchText}`;
        }
        if(params?.storeNames) {
            queryParams += `&storeNames=${params.storeNames}`;
        }
        if(params?.fromDate) {
            queryParams += `&fromDate=${params.fromDate}`;
        }
        if(params?.toDate) {
            queryParams += `&toDate=${params.toDate}`;
        }
        console.log("--- queryParams:", queryParams);
        const res = await axios.get(`${process.env.REACT_APP_API_ENDPOINT_URL}/ivt_yeu_cau_mua_hang/list${queryParams}`);
        //console.log("--- res", res)
        if(res.data.data) {
            const datas = _.orderBy(res.data.data, ["ro_date"], ['desc'])
            setIvtYeuCauMuaHangs(datas);
        }
        setIsLoading(false);
    }

    const handlePageClick = (event) => {
        navigate(`/order-management?page=${event.selected}`);
    } 

    const handleSearchByDate = async() => {
        if(!selectedStoreNames) {
            alert("Vui lòng chọn cửa hàng!");
            return;
        } else if(!selectedFromDate) {
            alert("Vui lòng chọn ngày bắt đầu!");
            return;
        } else if(!selectedToDate) {
            alert("Vui lòng chọn ngày kết thúc!");
            return;
        }

        setIsLoading(true);
        await sleep(250);
        await getIVTYeuCauMuaHangs({ 
            searchText, 
            storeNames: selectedStoreNames.map(item => item.value).join("|"),
            fromDate: Math.floor(selectedFromDate.getTime() / 1000), 
            toDate: Math.floor(selectedToDate.getTime() / 1000) 
        });
        setIsLoading(false);
    }

     const handleDownload = async() => {
        setIsExportPDF(true);
        const element = htmlDownloadRef.current;
        const canvas = await html2canvas(element, {
            scale: 2,
        });
        const data = canvas.toDataURL("image/png");
        const pxToMm = (px) => px * 0.264583;

        const width = pxToMm(canvas.width);
        const height = pxToMm(canvas.height);

        // const pdf = new jsPDF("p", "mm", "a4");
        // const imgProps = pdf.getImageProperties(data);
        // const pdfWidth = pdf.internal.pageSize.getWidth();
        // const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;    

        const pdf = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: [width, height] // 🔥 dynamic size
        });
        console.log("PDF width:", width, "PDF height:", height);
        
        pdf.addImage(data, "PNG", 0, 0, width/1.5, height);
        pdf.save(`report_${Date.now()}.pdf`);
        setIsExportPDF(false);
    }

    return (
        <Flex flexDirection="column" p={4}>
            <Heading size="lg">Quản lý đơn hàng</Heading>
            <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} flexWrap="wrap" justify="space-between" mt={4} gap={4}>
                <Flex flexDirection="row" gap={4}>
                    <Text>Chọn chi nhánh:</Text>
                    <div style={{ minWidth: "250px"}}>
                        <MultiSelect 
                            options={
                                settingDatas?.stores?.sort((a, b) => a?.warehouse_name.localeCompare(b?.warehouse_name)).map((item, idx) => (
                                    { label: item?.warehouse_name, value: item?.warehouse_name }
                                )) || []
                            } 
                            minWidth="200px"
                            value={selectedStoreNames}
                            onChange={setSelectedStoreNames}
                            labelledBy='Select'
                        />
                    </div>

                    <Text>Chọn từ ngày:</Text>
                    <DatePicker
                        value={selectedFromDate}
                        onChange={setSelectedFromDate}
                        className="react-date-picker-custom"
                        format='dd/MM/yyyy'                                                
                    />

                    <Text>Chọn đến ngày:</Text>
                    <DatePicker
                        value={selectedToDate}
                        onChange={setSelectedToDate}
                        className="react-date-picker-custom"
                        format='dd/MM/yyyy'                                                
                    />

                    <Button
                        px={8}
                        colorScheme="blue"
                        onClick={() => {
                            handleSearchByDate();
                        }
                    }>
                        <Icon as={MdSearch} boxSize={6}/> Tìm theo ngày
                    </Button>
                    <Button
                        px={8}
                        colorScheme="orange"
                        size="md"
                        isLoading={isExportPDF}
                        loadingText="Đang xuất PDF"
                        isDisabled={ivtYeuCauMuaHangs?.length === 0}
                        onClick={() => {
                            handleDownload();
                        }
                    }>
                        <Icon as={MdDownload} boxSize={6}/> In PDF
                    </Button>
                </Flex>

                <Flex flexDirection={{ base: "column", md: "row", lg: "row" }}>
                    <InputGroup>
                        <InputLeftElement pointerEvents="none">
                            <Icon as={MdSearch} color="gray.300" />
                        </InputLeftElement>
                        <Input value={searchText} placeholder="Tìm kiếm thông tin" 
                            onChange={(evt) => {setSearchText(evt.currentTarget.value); }}
                            onKeyUp={(evt) => {
                                if(evt.key === "Enter") {
                                    //loadUsers();
                                    console.log("---- searchText", searchText);
                                    getIVTYeuCauMuaHangs({ searchText, limit, order_by, order_dir });
                                }
                            }}
                        />
                        
                        <InputRightAddon p={0}>
                            <Button 
                                onClick={() => {
                                    console.log("---- searchText", searchText);
                                    getIVTYeuCauMuaHangs({ searchText, limit, order_by, order_dir });
                                }
                            }>
                                Tìm kiếm
                            </Button>
                        </InputRightAddon>
                    </InputGroup>
                </Flex>
            </Flex>
                        
            <Alert mt={4}>
                <AlertTitle>
                    *** Thời gian Purchasing xác nhận đơn hàng hợp lệ từ {MAX_PURCHASING_APPROVE} ngày tính từ ngày AM duyệt
                </AlertTitle>
            </Alert>
            <Alert status="warning">
                <AlertTitle>
                    *** Thời gian nhân viên Kho nhập mua hàng hợp lệ từ {MAX_SUPPLIER_DELIVERY} ngày tính từ đặt mua hàng
                </AlertTitle>
            </Alert>

            <TableContainer ref={htmlDownloadRef} minH="100vh" mt={4}>
                 <Table variant="simple" size="sm">
                     <Thead>
                        <Tr textTransform="uppercase">
                            <Th>PHIẾU ĐẶT HÀNG</Th>
                            <Th>PHIẾU MUA HÀNG/ NHẬP MUA HÀNG</Th>
                            {/* <Th>NGÀY TẠO</Th>    */}
                            <Th>KHO</Th>         
                            <Th>AM XÁC NHẬN</Th>
                            <Th>PURCHASING XÁC NHẬN</Th>
                            <Th>TRẠNG THÁI</Th>
                            {/* <Th>THỜI GIAN PURCHASING XÁC NHẬN</Th> */}
                         </Tr>
                     </Thead>
                     <Tbody>
                        {
                            ivtYeuCauMuaHangs.map((item, idx) => {
                                const { ro_id, created_at, ro_status, warehouse_name, action_records, listNhapMuaHang } = item;
                                console.log("_---------- ITEM:", item)
                                //console.log("--- action_record:", action_records)
                                // AM xác nhận
                                let findActionRecordByAM = action_records?.find(record => record.action_id === 3);
                                //console.log("--- findActionRecordByAM:", findActionRecordByAM)
                                // Purchasing xác nhận
                                let findActionRecordByPurchasing = action_records?.find(record => record.action_id === 5);
                                // console.log("---- created_at:", created_at)
                                // console.log("findActionRecord:", findActionRecord);
                                // *** Xác định xem trạng thái đơn hàng có bị trễ không;
                                let totalDayPurchasingConfirm = 0;
                                if (findActionRecordByPurchasing?.time_stamp) {
                                    //const createdAt = new Date(created_at * 1000);
                                    const amConfirmAt = new Date(findActionRecordByAM.time_stamp * 1000);
                                    const purchasingConfirmAt = findActionRecordByPurchasing?.time_stamp 
                                        ? new Date(findActionRecordByPurchasing.time_stamp * 1000)
                                        : new Date();

                                    totalDayPurchasingConfirm = Math.ceil((purchasingConfirmAt - amConfirmAt) / (1000 * 60 * 60 * 24));
                                }

                                //console.log("---- totalDayPurchasingConfirm", totalDayPurchasingConfirm)

                                return (
                                    <Tr key={ro_id}>
                                        <Td>
                                            <Flex flexDirection="column">
                                                <Text fontWeight="bold">{ro_id}</Text>
                                                <FormattedDate value={new Date(created_at * 1000)} />
                                            </Flex>
                                        </Td>
                                        <Td>
                                            {item?.referer_info?.map(doc => {
                                                const findPhieuNhap = listNhapMuaHang.find(docNhap => docNhap.referer_info.some(ref => ref.financial_paper_id === doc.financial_paper_id));
                                                //console.log("---- findPhieuNhap", findPhieuNhap);
                                                const totalDayVendorDeliveried = Math.ceil(((findPhieuNhap?.gr_date || Math.floor(new Date().getTime() / 1000)) - doc.financial_paper_require_time) / 86400);
                                                console.log("--- totalDayVendorDeliveried", totalDayVendorDeliveried, Math.floor(Date.now() / 1000), doc.financial_paper_require_time)
                                                return (
                                                    <Flex flexDirection="row" key={doc.id} my={3} gap={4}>
                                                        <Flex flexDirection="column" key={doc.id} my={3}>
                                                            <Text color="red" fontWeight="bold">{doc.financial_paper_id}</Text>
                                                            <FormattedDate value={new Date(doc.financial_paper_require_time * 1000)} />
                                                        </Flex>
                                                        <Flex flexDirection="column" key={findPhieuNhap?.id} my={3}>
                                                            <Text color="blue" fontWeight="bold">{findPhieuNhap?.gr_id}</Text>
                                                            { findPhieuNhap?.gr_date && <FormattedDate value={new Date(findPhieuNhap?.gr_date * 1000)} /> }
                                                        </Flex>
                                                        <Flex flexDirection="column" key={`totalDay-${doc.id}`} my={3}>
                                                            {/* <Text fontWeight="bold">Trạng thái: {totalDayVendorDeliveried} ngày</Text> */}
                                                            {
                                                                totalDayVendorDeliveried <= MAX_SUPPLIER_DELIVERY ?
                                                                    <Badge colorScheme="blue" p={1}>NCC đúng hạn</Badge> :
                                                                    <Badge colorScheme="red" p={1}>Trễ hạn ({totalDayVendorDeliveried} ngày)</Badge>
                                                            }
                                                        </Flex>
                                                    </Flex>
                                                )
                                            })}
                                        </Td>
                                        {/* <Td>
                                            <Text fontWeight="600">
                                                <FormattedDate value={new Date(created_at * 1000)} />
                                            </Text></Td>   */}
                                        <Td maxWidth="150px" whiteSpace="wrap">
                                            <Text fontWeight="600">{warehouse_name}</Text>
                                        </Td>
                                        {/* <Td>
                                            { 
                                                (ro_status === "CONFIRMED" ? 
                                                    <Badge colorScheme="green">Đã xác nhận</Badge> : <Text>{ro_status}</Text>)
                                            }
                                        </Td> */}
                                        <Td>
                                            <Flex flexDirection="column" justify="center">
                                                <Text fontWeight="600" color="green.500">{findActionRecordByAM?.user_name || ""}</Text>
                                                <Text fontWeight="600">
                                                    {findActionRecordByAM?.time_stamp ? <FormattedDate value={new Date(findActionRecordByAM.time_stamp * 1000)} /> : ""}
                                                </Text>
                                            </Flex>
                                        </Td>
                                        <Td>
                                            <Flex flexDirection="column" justify="center">
                                                <Text fontWeight="600" color="orange.500">{findActionRecordByPurchasing?.user_name || ""}</Text>
                                                <Text fontWeight="600">
                                                    {findActionRecordByPurchasing?.time_stamp ? <FormattedDate value={new Date(findActionRecordByPurchasing.time_stamp * 1000)} /> : ""}
                                                </Text>
                                            </Flex>
                                        </Td>
                                        <Td>
                                            {
                                                totalDayPurchasingConfirm <= MAX_PURCHASING_APPROVE ?
                                                    <Badge colorScheme="green" p={1}>Purchasing Đúng hạn</Badge> :
                                                    <Badge colorScheme="red" p={1}>Trễ hạn ({totalDayPurchasingConfirm} ngày)</Badge>
                                            }
                                        </Td>
                                    </Tr>
                                )
                            })
                        }
                    </Tbody>
                </Table>
            </TableContainer>
            {
                isLoading &&
                <Center>
                    <CircularProgress position="fixed" top="20vh" isIndeterminate size="100px" zIndex={9999}>
                        <CircularProgressLabel fontSize="14px" fontWeight="700" color="#2196f3">Đang tải</CircularProgressLabel>
                    </CircularProgress>
                </Center>
            }
        </Flex>
    )
}

export default QuanLyDonHang;